<template>
  <div class="grid" v-if="clienteData">

    <div class="col-12">
      <h6 class="">Obra #547 <i> (José da Silva) </i></h6>
      <Toolbar class="mb-4">
        <template v-slot:start>
          <div class="my-2">
            <Button label="Salvar" icon="pi pi-save" class="p-button-success mr-2" @click="saveCliente" />
            <Button label="Exportar" icon="pi pi-download" class="mr-2 p-button-outlined" @click="exportCSV($event)"  />
            <Button label="Importar" icon="pi pi-upload" class="mr-2 p-button-outlined" @click="exportCSV($event)"  />
          </div>
        </template>
        <template v-slot:end>
          <Button label="Voltar" icon="pi pi-backward" class="p-button-outlined mr-2" @click="$router.go(-1)" />
        </template>
      </Toolbar>
    </div>

    <div class="col-12">
      <TabView>
        <TabPanel header="Cliente">

          <div class="p-fluid formgrid grid">
            <div class="field col-12 md:col-6">
              <label for="cpf">CPF</label>
              <div class="p-inputgroup">
                <InputText placeholder="000.000.000-00" v-model="clienteData.cpf" :readonly="true" />
                <!--                <Button label="Pesquisar CPF"/>-->
              </div>
            </div>


            <div class="field col-12 md:col-6">
              <label for="nome">Nome</label>
              <InputText id="nome" type="text" v-model="clienteData.nome" :readonly="true" />
            </div>

            <div class="field col-12 md:col-6">
              <label for="email">E-mail</label>
              <InputText id="email" type="text" v-model="clienteData.email" :readonly="true" />
            </div>
            <div class="field col-12 md:col-6">
              <label for="telefone">Telefone</label>
              <InputText id="telefone" type="text" v-model="clienteData.telefone" :readonly="true" />
            </div>



            <div class="field col-12 md:col-6">
              <label for="cep">CEP</label>
              <div class="p-inputgroup">
                <InputText placeholder="00.000-000" v-model="clienteData.cep" :readonly="true" />

              </div>
            </div>

            <div class="field col-12 md:col-6">
              <label for="cidade">Cidade</label>
              <InputText id="cidade" type="text" v-model="clienteData.cidade" :readonly="true" />
            </div>

            <div class="field col-12 md:col-6">
              <label for="logradouro">Logradouro</label>
              <InputText id="logradouro" type="text" v-model="clienteData.logradouro" :readonly="true" />
            </div>
            <div class="field col-12 md:col-6">
              <label for="numero">Número</label>
              <InputText id="numero" type="text" v-model="clienteData.numero" :readonly="true" />
            </div>


            <div class="field col-12 md:col-6">
              <label for="estado">Estado</label>
              <Dropdown id="estado" v-model="clienteData.estado" :options="dropdownItems" optionLabel="name" placeholder="ES"  :readonly="true" ></Dropdown>
            </div>

            <div class="field col-12">
              <label for="obs">Observações</label>
              <Textarea id="obs" rows="4" v-model="clienteData.obs"  :readonly="true" />
            </div>




          </div>

        </TabPanel>



        <TabPanel header="Local de Instalação">
          <div class="p-fluid formgrid grid">

            <div class="field col-12 md:col-6">
              <label for="cep">CEP</label>
              <div class="p-inputgroup">
                <InputText placeholder="00.000-000" v-model="clienteData.cep" :readonly="true" />
                <Button label="Pesquisar CEP"/>
              </div>
            </div>

            <div class="field col-12 md:col-6">
              <label for="cidade">Cidade</label>
              <InputText id="cidade" type="text" v-model="clienteData.cidade" :readonly="true" />
            </div>

            <div class="field col-12 md:col-6">
              <label for="logradouro">Logradouro</label>
              <InputText id="logradouro" type="text" v-model="clienteData.logradouro" :readonly="true" />
            </div>
            <div class="field col-12 md:col-6">
              <label for="numero">Número</label>
              <InputText id="numero" type="text" v-model="clienteData.numero" :readonly="true" />
            </div>


            <div class="field col-12 md:col-6">
              <label for="estado">Estado</label>
              <Dropdown id="estado" v-model="clienteData.estado" :options="dropdownItems" optionLabel="name" placeholder="ES"  :readonly="true" ></Dropdown>
            </div>

            <div class="field col-12">
              <label for="obs">Observações</label>
              <Textarea id="obs" rows="4" v-model="clienteData.obs"  :readonly="true" />
            </div>

          </div>
        </TabPanel>


        <TabPanel header="Sistema">

          <div class="p-fluid formgrid grid">

            <div class="field col-12 md:col-6">
              <label for="consmed">Consumo Cliente KWh</label>
              <InputText id="consmed" type="text" v-model="clienteData.consmedio"/>
            </div>
            <div class="field col-12 md:col-6">
              <label for="potsist">Potência do Sistema KWp</label>
              <InputNumber id="potsist" v-model="clienteData.potsist"/>
            </div>

            <div class="field col-12 md:col-6">
              <label for="fornecedor">Fornecedor</label>
              <Dropdown id="fornecedor" v-model="clienteData.fornecedor" :options="fornecedorItems" optionLabel="name" placeholder="Selecione fornecedor"  ></Dropdown>
            </div>

            <div class="field col-12 md:col-6">
              <label for="projeto">Tipo de Projeto</label>
              <Dropdown id="projeto" v-model="clienteData.projeto" :options="projetoItems" optionLabel="name" placeholder="Selecione tipo de projeto"  ></Dropdown>
            </div>

            <div class="field col-12 md:col-6">
              <label for="tipoconex">Tipo de Conexão</label>
              <Dropdown id="tipoconex" v-model="clienteData.conexao" :options="conexaoItems" optionLabel="name" placeholder="Selecione conexão"  ></Dropdown>
            </div>

            <div class="field col-12 md:col-6">
              <label for="tipoestr">Tipo de Estrutura</label>
              <Dropdown id="estado" v-model="clienteData.tipoestr" :options="estruturaItems" optionLabel="name" placeholder="Selecione tipo de estrutura"  ></Dropdown>
            </div>

            <div class="field col-12 md:col-12">
              <label for="obssistema">Observações</label>
              <Textarea id="obssistema" rows="4" v-model="clienteData.obssistema"  />
            </div>

            <div class="field col-12 md:col-6">
              <label for="tiposistema">tiposistema</label>
              <Dropdown id="tiposistema" v-model="clienteData.tiposistema" :options="tiposistemaItems" optionLabel="name" placeholder="Selecione o tipo de sistema"  :readonly="true" ></Dropdown>
            </div>

            <div class="field col-12 md:col-6">
              <label for="undcons">Unidade Consumidora</label>
              <InputText id="undcons" type="text" v-model="clienteData.undcons"/>
            </div>

            <div class="field col-12 md:col-12">
              <label for="undprincp">Unidades Principais</label>
              <Textarea id="undprincp" rows="3" v-model="clienteData.undprincp"  />
            </div>

            <div class="field col-12 md:col-6">
              <label for="coordslocal">Coordenada Local</label>
              <InputText id="coordslocal" type="text" v-model="clienteData.coordslocal" placeholder="S'"/>
            </div>

            <div class="field col-12 md:col-6">
              <label for="coordsposte">Coordenada Poste Mais Próximo</label>
              <InputText id="coordsposte" type="text" v-model="clienteData.coordslocal" placeholder="S'"/>
            </div>

            <div class="field col-12 md:col-6">
              <label for="coordwlocal">Coordenada Local</label>
              <InputText id="coordwlocal" type="text" v-model="clienteData.coordslocal" placeholder="W'"/>
            </div>

            <div class="field col-12 md:col-6">
              <label for="coordwposte">Coordenada Poste Mais Próximo</label>
              <InputText id="coordwposte" type="text" v-model="clienteData.coordslocal" placeholder="W'"/>
            </div>


            <div class="field col-12 md:col-12">
              <label for="levancarga">Levantamento de Carga</label>
              <Textarea id="levancarga" rows="3" v-model="clienteData.levancarga"  />
            </div>



            <div class="field col-12 md:col-12">
              <h5 class="mt-2 mb-6">Checklist</h5>
              <div class="grid">
                <div class="col-5 align-items-center justify-content-center">
                  <h6>Disjuntor de Proteção</h6>
                  <InputSwitch v-model="clienteData.disjprotec" />
                  <h6>Disjuntor Mediador</h6>
                  <InputSwitch v-model="clienteData.disjmedia" />
                </div>
                <div class="col-1">
                  <Divider layout="vertical">
                    <b></b>
                  </Divider>
                </div>
                <div class="col-5 align-items-center justify-content-center">
                  <h6>Aterramento</h6>
                  <InputSwitch v-model="clienteData.aterramento" />
                  <h6>Placas de Sinalização</h6>
                  <InputSwitch v-model="clienteData.placasinal" />
                </div>
              </div>
            </div>


            <div class="field col-12 md:col-12">
              <h5 class="mt-2">Dados Acesso Inversor</h5>
            </div>

            <div class="field col-12 md:col-6">
              <label for="logininv">Login</label>
              <InputText id="logininv" type="text" v-model="clienteData.logininv" placeholder="login inversor"/>
            </div>
            <div class="field col-12 md:col-6">
              <label for="senhainv">Senha</label>
              <InputText id="senhainv" type="text" v-model="clienteData.coordslocal" placeholder="senha inversor"/>
            </div>


          </div>
        </TabPanel>


        <TabPanel header="Fotos e Vídeos">


          <div class="grid">
            <div class="col-4 align-items-center justify-content-center">

              <Divider layout="horizontal" align="center">
                <span class="">Imagens do Projeto</span>
              </Divider>
              <h6>Projetos</h6>
              <FileUpload choose-label="Upload de arquivo" mode="basic" name="demo[]" url="./upload.php" accept="image/*" :maxFileSize="1000000" @upload="onUpload" />
              <h6>Parecer de Acesso</h6>
              <FileUpload choose-label="Upload de arquivo" mode="basic" name="demo[]" url="./upload.php" accept="image/*" :maxFileSize="1000000" @upload="onUpload" />
              <h6>ART</h6>
              <FileUpload choose-label="Upload de arquivo" mode="basic" name="demo[]" url="./upload.php" accept="image/*" :maxFileSize="1000000" @upload="onUpload" />
              <h6>Arquivos Adicionais</h6>
              <FileUpload choose-label="Upload de arquivo" mode="basic" name="demo[]" url="./upload.php" accept="image/*" :maxFileSize="1000000" @upload="onUpload" />

            </div>
            <div class="col-1">
              <Divider layout="vertical">
                <b></b>
              </Divider>
            </div>

            <div class="col-4 align-items-center justify-content-center">

              <Divider layout="horizontal" align="center">
                <span class="">Imagens da Obra</span>
              </Divider>

              <h6>Inversor</h6>
              <FileUpload choose-label="Upload de arquivo" mode="basic" name="demo[]" url="./upload.php" accept="image/*" :maxFileSize="1000000" @upload="onUpload" />

              <h6>Telhado</h6>
              <FileUpload choose-label="Upload de arquivo" mode="basic" name="demo[]" url="./upload.php" accept="image/*" :maxFileSize="1000000" @upload="onUpload" />

              <h6>Painéis Instalados</h6>
              <FileUpload choose-label="Upload de arquivo" mode="basic" name="demo[]" url="./upload.php" accept="image/*" :maxFileSize="1000000" @upload="onUpload" />

              <h6>Padrão com Placa de Advertência</h6>
              <FileUpload choose-label="Upload de arquivo" mode="basic" name="demo[]" url="./upload.php" accept="image/*" :maxFileSize="1000000" @upload="onUpload" />

              <h6>Placa do Transformador</h6>
              <FileUpload choose-label="Upload de arquivo" mode="basic" name="demo[]" url="./upload.php" accept="image/*" :maxFileSize="1000000" @upload="onUpload" />

              <h6>Sistema de Aterramento</h6>
              <FileUpload choose-label="Upload de arquivo" mode="basic" name="demo[]" url="./upload.php" accept="image/*" :maxFileSize="1000000" @upload="onUpload" />

              <h6>Disjuntores CA</h6>
              <FileUpload choose-label="Upload de arquivo" mode="basic" name="demo[]" url="./upload.php" accept="image/*" :maxFileSize="1000000" @upload="onUpload" />

              <h6>String Box / DPS</h6>
              <FileUpload choose-label="Upload de arquivo" mode="basic" name="demo[]" url="./upload.php" accept="image/*" :maxFileSize="1000000" @upload="onUpload" />

              <h6>Disjuntor do Padrão</h6>
              <FileUpload choose-label="Upload de arquivo" mode="basic" name="demo[]" url="./upload.php" accept="image/*" :maxFileSize="1000000" @upload="onUpload" />

              <h6>Número do Relógio</h6>
              <FileUpload choose-label="Upload de arquivo" mode="basic" name="demo[]" url="./upload.php" accept="image/*" :maxFileSize="1000000" @upload="onUpload" />

              <h6>Arquivos Adicionais</h6>
              <FileUpload choose-label="Upload de arquivo" mode="basic" name="demo[]" url="./upload.php" accept="image/*" :maxFileSize="1000000" @upload="onUpload" />
            </div>


          </div>



        </TabPanel>



        <TabPanel header="Colaboradores">

          <div class="p-fluid formgrid grid">

            <div class="field col-12 md:col-6">
              <label for="instalacao">Instalação</label>
              <Dropdown id="instalacao" v-model="clienteData.instalacao" :options="instalacaoItems" optionLabel="name" placeholder="Selecione o colaborador"  ></Dropdown>
            </div>

            <div class="field col-12 md:col-6">
              <label for="engenharia">Engenharia</label>
              <Dropdown id="engenharia" v-model="clienteData.engenharia" :options="instalacaoItems" optionLabel="name" placeholder="Selecione o colaborador"  ></Dropdown>
            </div>

          </div>
        </TabPanel>

        <TabPanel header="Leads">

          <DataTable v-if="leadsData" :value="leadsData" :scrollable="true" scrollHeight="400px" :loading="loadingLeads" scrollDirection="both" class="mt-3">

            <Column header="Ações" class="text-right" :style="{width:'100px'}" >
              <template #body="">
                <Button icon="pi pi-eye" class="p-button-rounded p-button-success mr-2" @click="$router.push('/leads')" />
              </template>
            </Column>

            <Column field="code" header="Código" :style="{width:'100px'}" ></Column>

            <Column header="Data" :style="{width:'200px'}">
              <template #body="slotProps">
                {{formatDate(slotProps.data.date)}}
              </template>
            </Column>

            <Column field="representante" header="Representante" :style="{width:'200px'}"></Column>
            <Column field="inventoryStatus" header="Status" :style="{width:'200px'}">
              <template #body="{data}">
                <span :class="'lead-badge status-' + (data.inventoryStatus ? data.inventoryStatus.toLowerCase() : '')">{{data.inventoryStatus}}</span>
              </template>
            </Column>

            <Column field="rating" header="Visualizações" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Rating</span>
                <Rating :modelValue="slotProps.data.rating" :readonly="true" :cancel="false" />
              </template>
            </Column>

            <Column field="price" header="Valor" :style="{width:'150px'}" frozen alignFrozen="right">
              <template #body="{data}">
                <span class="text-bold">{{formatCurrency(data.price)}}</span>
              </template>
            </Column>
            <Column field="potencia" header="Potência" :style="{width:'150px'}" frozen alignFrozen="right">
              <template #body="{data}">
                <span class="text-bold">{{formatDecimal(data.potencia)}}</span>
              </template>
            </Column>
          </DataTable>


        </TabPanel>

        <TabPanel header="Orçamentos">

          <DataTable v-if="orcamentosData" :value="orcamentosData" :scrollable="true" scrollHeight="400px" :loading="loadingLeads" scrollDirection="both" class="mt-3">
            <Column header="Ações" class="text-right" :style="{width:'100px'}" >
              <template #body="">
                <Button icon="pi pi-eye" class="p-button-rounded p-button-success mr-2" @click="$router.push('/orcamentodetalhe')" />
              </template>
            </Column>
            <Column field="id" header="Código" :style="{width:'100px'}" ></Column>
            <Column header="Data" :style="{width:'200px'}">
              <template #body="slotProps">
                {{formatDate(slotProps.data.date)}}
              </template>
            </Column>
            <Column header="Representante" :style="{width:'200px'}">
              <template #body="slotProps">
                {{slotProps.data.representative.name}}
              </template>
            </Column>
            <Column header="Cidade" :style="{width:'200px'}">
              <template #body="slotProps">
                {{slotProps.data.cidade}}
              </template>
            </Column>
            <Column header="Estado" :style="{width:'200px'}">
              <template #body="slotProps">
                {{slotProps.data.estado}}
              </template>
            </Column>
            <Column field="status" header="Status" :style="{width:'200px'}">
              <template #body="{data}">
                <span :class="'orcamento-badge status-' + (data.status ? data.status.toLowerCase() : '')">{{data.status}}</span>
              </template>
            </Column>
            <Column field="price" header="Valor" :style="{width:'150px'}" frozen alignFrozen="right">
              <template #body="{data}">
                <span class="text-bold">{{formatCurrency(data.balance)}}</span>
              </template>
            </Column>
            <Column field="potencia" header="Potência" :style="{width:'150px'}" frozen alignFrozen="right">
              <template #body="{data}">
                <span class="text-bold">{{formatDecimal(data.potencia)}}</span>
              </template>
            </Column>
          </DataTable>

        </TabPanel>


        <TabPanel header="Vendas">

          <DataTable v-if="pedidosData" :value="pedidosData" :scrollable="true" scrollHeight="400px" :loading="loadingLeads" scrollDirection="both" class="mt-3">
            <Column header="Ações" class="text-right" :style="{width:'100px'}" >
              <template #body="">
                <Button icon="pi pi-eye" class="p-button-rounded p-button-success mr-2" @click="$router.push('/pedidodetalhe')" />
              </template>
            </Column>
            <Column field="id" header="Código" :style="{width:'100px'}" ></Column>
            <Column header="Data" :style="{width:'200px'}">
              <template #body="slotProps">
                {{formatDate(slotProps.data.date)}}
              </template>
            </Column>
            <Column header="Representante" :style="{width:'200px'}">
              <template #body="slotProps">
                {{slotProps.data.representative.name}}
              </template>
            </Column>
            <Column header="Cidade" :style="{width:'200px'}">
              <template #body="slotProps">
                {{slotProps.data.cidade}}
              </template>
            </Column>
            <Column header="Estado" :style="{width:'200px'}">
              <template #body="slotProps">
                {{slotProps.data.estado}}
              </template>
            </Column>
            <Column field="status" header="Status" :style="{width:'200px'}">
              <template #body="{data}">
                <span :class="'pedido-badge status-' + (data.status ? data.status.toLowerCase() : '')">{{data.status}}</span>
              </template>
            </Column>
            <Column field="price" header="Valor" :style="{width:'150px'}" frozen alignFrozen="right">
              <template #body="{data}">
                <span class="text-bold">{{formatCurrency(data.balance)}}</span>
              </template>
            </Column>
            <Column field="potencia" header="Potência" :style="{width:'150px'}" frozen alignFrozen="right">
              <template #body="{data}">
                <span class="text-bold">{{formatDecimal(data.potencia)}}</span>
              </template>
            </Column>
          </DataTable>

        </TabPanel>


        <TabPanel header="Projetos">
          <DataTable v-if="projetosData" :value="projetosData" :scrollable="true" scrollHeight="400px" :loading="loadingLeads" scrollDirection="both" class="mt-3">
            <Column header="Ações" class="text-right" :style="{width:'100px'}" >
              <template #body="">
                <Button icon="pi pi-eye" class="p-button-rounded p-button-success mr-2" @click="$router.push('/projetodetalhe')" />
              </template>
            </Column>
            <Column field="id" header="Código" :style="{width:'100px'}" ></Column>
            <Column header="Data" :style="{width:'200px'}">
              <template #body="slotProps">
                {{formatDate(slotProps.data.date)}}
              </template>
            </Column>
            <Column header="Representante" :style="{width:'200px'}">
              <template #body="slotProps">
                {{slotProps.data.representative.name}}
              </template>
            </Column>
            <Column header="Cidade" :style="{width:'200px'}">
              <template #body="slotProps">
                {{slotProps.data.cidade}}
              </template>
            </Column>
            <Column header="Estado" :style="{width:'200px'}">
              <template #body="slotProps">
                {{slotProps.data.estado}}
              </template>
            </Column>
            <Column field="status" header="Status" :style="{width:'200px'}">
              <template #body="{data}">
                <span :class="'projeto-badge status-' + (data.status ? data.status.toLowerCase() : '')">{{data.status}}</span>
              </template>
            </Column>
            <Column field="price" header="Valor" :style="{width:'150px'}" frozen alignFrozen="right">
              <template #body="{data}">
                <span class="text-bold">{{formatCurrency(data.balance)}}</span>
              </template>
            </Column>
            <Column field="potencia" header="Potência" :style="{width:'150px'}" frozen alignFrozen="right">
              <template #body="{data}">
                <span class="text-bold">{{formatDecimal(data.potencia)}}</span>
              </template>
            </Column>
          </DataTable>


        </TabPanel>


        <TabPanel header="3D">

<!--          <model-viewer-->
<!--              :src="'layout/gltf/0001.glb'"-->
<!--              style=""-->
<!--              loading="eager"-->
<!--              camera-controls-->
<!--              enable-pan-->
<!--              seamless-poster-->
<!--              shadow-intensity="1"-->
<!--              ar-->
<!--              ar-placement="floor"-->
<!--              ar-modes="webxr scene-viewer quick-look">-->

<!--          </model-viewer>-->

        </TabPanel>


      </TabView>
    </div>

    <div class="col-12">
      <cliente-detalhe-timeline></cliente-detalhe-timeline>
    </div>




  </div>
</template>
<script>
// import '@google/model-viewer';
import ClienteDetalheTimeline from "@/components_esol/clientes/ClienteDetalheTimeline";
import LeadService from "@/service/LeadService";


export default {
  components: {ClienteDetalheTimeline},
  data() {
    return {
      pedidosData: null,
      orcamentosData: null,
      projetosData: null,

      loadingLeads: true,
      leadService: null,
      leadsData: null,
      clienteData: null,
      tiposistemaItems: [
        {name: 'Individual', code: 'IND'},
        {name: 'Compartilhado', code: 'COM'},
      ],
      instalacaoItems: [
        {name: 'Colaborador Testes 001', code: 'CL01'},
        {name: 'Colaborador Testes 002', code: 'CL02'},
        {name: 'Colaborador Testes 003', code: 'CL03'},
      ],
      estruturaItems: [
        {name: 'Solo', code: 'Solo'},
        {name: 'Trapezoidal', code: 'Trapezoidal'},
        {name: 'Fibrocimento Parafuso Metal', code: 'Fibrocimento Parafuso Metal'},
        {name: 'Fibrocimento Parafuso Madeira', code: 'Fibrocimento Parafuso Madeira'},
        {name: 'Ondulada', code: 'Ondulada'},
        {name: 'Romagnole', code: 'Romagnole'},
        {name: 'Laje', code: 'Laje'},
        {name: 'Colonial', code: 'Colonial'},
        {name: 'Zipada', code: 'Zipada'},
      ],
      fornecedorItems: [
        {name: 'Aldo', code: 'Aldo'},
      ],
      projetoItems: [
        {name: 'On Grid', code: 'OG'},
      ],

      conexaoItems: [
        {name: 'Monofásica', code: 'MN'},
        {name: 'Bifásica', code: 'BI'},
        {name: 'Trifásica', code: 'TR'},
      ],
      formaItems: [
        {name: 'Financiamento', code: 'Financiamento'},
        {name: 'Boleto', code: 'Boleto'},
        {name: 'PIX', code: 'PIX'},
      ],
      bancoItems: [
        {name: 'Sicoob', code: 'Sicoob'},
      ],
      dropdownItems: [
        {name: 'ES', code: 'ES'},
        {name: 'MG', code: 'MG'},
        {name: 'RJ', code: 'RJ'}
      ],
      dropdownItem: null,
    }
  },

  created() {
    this.leadService = new LeadService();

  },

  mounted() {
    this.clienteData =
        {
          cpf: '123.456.789-00',
          codigo: '123',
          nome: 'Cliente Testes 001',
          cep: '123.123-00',
          cidade: 'Belo Horizonte',
          logradouro: 'Rua testes',
          email: 'comercial@dominio.com.br',
          telefone: '00.1234-1234',
          numero: '032',
          estado: 'MG',
          obs: ''
        }

    this.leadService.getLeads().then((data) => {
      console.log('obraDetalhe_0')
      this.leadsData = data
      this.loadingLeads = false
      // console.log(this.leadsData)
      this.leadsData.forEach(lead => lead.date = new Date(lead.date));
    });


    this.leadService.getOrcamentos().then((data) => {
      this.orcamentosData = data
      // console.log(this.orcamentosData)
      this.orcamentosData.splice(0,6)
      // console.log(this.orcamentosData)
      this.orcamentosData.forEach(orcto => orcto.date = new Date(orcto.date));
    });

    this.leadService.getPedidos().then((data) => {
      this.pedidosData = data
      // console.log(this.pedidosData)
      this.pedidosData.splice(0,3)
      // console.log(this.pedidosData)
      this.pedidosData.forEach(pedido => pedido.date = new Date(pedido.date));
    });

    this.leadService.getProjetos().then((data) => {
      this.projetosData = data
      // console.log(this.pedidosData)
      this.projetosData.splice(0,8)
      // console.log(this.pedidosData)
      this.projetosData.forEach(obra => obra.date = new Date(obra.date));
    });

  },

  methods: {
    onUpload() {

    },

    saveCliente() {

    },
    formatDate(value) {
      return value.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
    },

    formatDecimal(value) {
      if(value)
        return value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      return;
    },

    formatCurrency(value) {
      return value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'});
    },
  },

  computed: {

  },
}
</script>

<style scoped lang="scss">
  @import '../../assets/demo/styles/badges.scss';

  model-viewer {
    width: 100vw; height: 50vh;
    --poster-color: transparent;
  }
</style>
